import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { trackViewportHeight } from "./viewport";
// Temml's own rules for <math>, plus the one small woff2 it needs for script capitals. The
// "Local" variant draws everything else with the reader's installed maths font instead of
// shipping a family of its own.
import "temml/dist/Temml-Local.css";
import "./styles.css";

trackViewportHeight();

createRoot(document.getElementById("root")!).render(
	<StrictMode>
		<App />
	</StrictMode>,
);
